import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import axios from 'axios';
import { API_ROOT } from 'api-config';
import { getApiHeaders } from '../../assets/helpers/apiHelper.jsx';
import { verifyDecimal } from '../../assets/helpers/formHelper.jsx';

class Financials extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId;
    if (props.userId) {
      userId = props.userId
    } else {
      userId = sessionStorage.getItem('userId')
    }

    this.state = {
      userId: userId,
      entity: '',
      entityId: 0,
      patientCount: '',
      billed: '',
      revenue: '',
      finanacials: [],
      updateFinancialsButtonText: 'update',
      showDeleteButton: true,
      updateProps: true
    };
  }

  componentDidMount(){
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  static getDerivedStateFromProps(nextProps, prevState){
    if(nextProps.financials.entityId!==prevState.entityId){
      return {
        entity: nextProps.entity,
        entityId: nextProps.financials.entityId,
        patientCount: nextProps.financials.patientCount ? nextProps.financials.patientCount : 0,
        billed: nextProps.financials.billed ? nextProps.financials.billed : 0,
        revenue: nextProps.financials.revenue ? nextProps.financials.revenue : 0,
        updateFinancialsButtonText: nextProps.financials.entity ? 'update' : 'add',
        showDeleteButton: nextProps.financials.entity && nextProps.financials.entity !== 'self' ? true : false,
        finanacials: nextProps.financials
      };
    }
    else return null;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  updateFinancials() {
    if (this.state.entity === '' || !verifyDecimal(this.state.patientCount) || !verifyDecimal(this.state.billed) ||
      !verifyDecimal(this.state.revenue)) {
      alert("Please make sure all fields have values in them and all fields other than the insurance name field contain only numbers.")
    } else {
      var financials = [{'entity': this.state.entity,
        'entityId': this.state.entityId,
        'patientCount': this.state.patientCount,
        'billed': this.state.billed,
        'revenue': this.state.revenue}]

      financials = JSON.stringify(financials)

      const financialsData = {
        userId: this.state.userId,
        financials: financials
      }

      axios.post(`${API_ROOT}/practiceSystem/financials/`, financialsData, { headers: getApiHeaders() })
        .then(res => this.handleUpdateFinancials(res));
    }

  }

  handleUpdateFinancials(res) {
    if (res.data.status && res.data.status === 'success') {
      this.props.onUpdate()
    } else {
      alert('There was an error saving the information.')
    }
  }

  deleteFinancials() {
    const forSure = window.confirm("Are you sure you want to delete the information for " + this.state.entity + "?")
    if (forSure) {
      const financialsData = {
        userId: this.state.userId,
        entityId: this.state.entityId
      }
      axios.delete(`${API_ROOT}/practiceSystem/financials/`, {data: financialsData,  headers: getApiHeaders() })
        .then(res => this.handleDeleteFinancials(res));
    }
  }

  handleDeleteFinancials(res) {
    if (res.data.status && res.data.status === 'success') {
      this.props.onUpdate()
    } else {
      alert('There was an error delete the information for ' + this.state.entity + '.')
    }
  }

  render() {
    return (
        <Card>
          <CardBody>

            <GridContainer>
              <GridItem xs={12} sm={12} md={12} style={this.state.entity === 'self' ? { display: 'none' } : {}}>
                <CustomInput
                  labelText="name"
                  type="text"
                  id="entity"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.entity,
                    disabled: this.state.inputDisabled
                  }}
                  customStyle={this.state.customInputStyle}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <CustomInput
                  labelText="billed (total annual)"
                  type="text"
                  id="billed"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.billed,
                    disabled: this.state.inputDisabled
                  }}
                  customStyle={this.state.customInputStyle}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <CustomInput
                  labelText="revenue (total annual)"
                  type="text"
                  id="revenue"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.revenue,
                    disabled: this.state.inputDisabled
                  }}
                  customStyle={this.state.customInputStyle}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <CustomInput
                  labelText="patient count (total active)"
                  type="text"
                  id="patientCount"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.patientCount,
                    disabled: this.state.inputDisabled
                  }}
                  customStyle={this.state.customInputStyle}
                />
              </GridItem>
            </GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Button
                round
                onClick={this.updateFinancials.bind(this)}
                color="cirrusBlue"
                disabled={this.state.inputDisabled}
                id="updateFinancialsButton"
              >
                {this.state.updateFinancialsButtonText}
              </Button>
              <Button
                style={this.state.showDeleteButton ? {} : { display: 'none' }}
                // style={showDeleteButton}
                round
                onClick={this.deleteFinancials.bind(this)}
                color="cirrusBlue"
                disabled={this.state.inputDisabled}
                id="deleteFinancialsButton"
              >
                delete
              </Button>


            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <div id={"invitationStatus"} style={{height: '30px'}} >
                {this.state.invitationStatusIndicator} {this.state.invitationStatus}
              </div>
            </GridItem>
          </CardBody>
        </Card>
    )

  }


}

export default withStyles(userProfileStyles)(Financials);